<template>
  <div>
    <div class="mt-5">
      <div class="b-form__container_type_flex">
        <h4>{{$t('CONTENT.discountRates.discount')}}</h4>
        <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.discountHint')" icon="question"></dynamic-icon>
      </div>
      <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-2">
          <label>{{$t('CONTENT.discountRates.rate')}}:<span class="b-form__required"> *</span></label>
          <numeric v-bind:class="{ 'b-numeric__error': isFieldWithError('discountPercent', discountPercent) }" class="b-numeric"  controls :min="0" :max="100" :disabled="isDisabledSetDiscountRate" v-model="discountPercent"></numeric>
        </div>
        <div class="col-2 b-form__container_type_flex mb-2">
          <checkbox class="b-checkbox" :id="`isAuto${paymentIndex}`" v-model="discountIsAuto">{{$t('CONTENT.discountRates.isAutoDiscount')}}</checkbox>
          <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.isAutoDiscountHint')" icon="question"></dynamic-icon>
        </div>
      </div>
      <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-4">
          <div>
            <label>{{$t('CONTENT.comment')}}:</label>
            <textarea class="b-textarea" v-model.lazy="discountComment"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lessorComponentSharesIndex: {
        type: Number,
        required: true,
      },
      payment: {
        type: Object
      },
      paymentIndex: {
        type: Number
      },
      assetComponentIndex: {
        type: Number
      },
      assetIndex: {
        type: Number
      },
      validationErrors: {
        type: Array
      }
    },
    computed: {
      isDisabledSetDiscountRate() {
        return !!this.discountIsAuto;
      },
      discountPercent: {
        get() {
          if (this.payment.discount.discountRate !== null) {
            return this.payment.discount.discountRate;
          }
        },
        set(newVal) {
          if(isNaN(newVal)) {
            this.$store.commit('assetComponentsPlugin/updatePaymentDiscount', {
              name: 'discountRate',
              value: null,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          } else {
            this.$store.commit('assetComponentsPlugin/updatePaymentDiscount', {
              name: 'discountRate',
              value: newVal,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          }

          if(!(this.payment.discount.isAuto && newVal !== null)) {
            this.onChangeData();
          }
        }
      },
      discountIsAuto: {
        get() {
          return this.payment.discount.isAuto;
        },
        set(newVal) {
          this.$store.commit('assetComponentsPlugin/updatePaymentDiscount', {
            name: 'isAuto',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });

          this.onChangeData();
        }
      },
      discountComment: {
        get() {
          if (this.payment.discount.commentary !== null) {
            return this.payment.discount.commentary;
          }
        },
        set(newVal) {
          this.$store.commit('assetComponentsPlugin/updatePaymentDiscount', {
            name: 'commentary',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });

          this.onChangeData();
        }
      }
    },
    watch: {
      discountIsAuto(newVal) {
        if(newVal) {
          this.$store.commit('assetComponentsPlugin/updatePaymentDiscount', {
            name: 'discountRate',
            value: null,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
        }
      }
    },
    methods: {
      onChangeData() {
        this.$emit('changeDiscount');
      },
      isFieldWithError(field, value) {
        if(!this.validationErrors || !this.validationErrors[this.payment.validationIndex]) {
          return;
        }
        return !value && this.validationErrors && this.validationErrors[this.payment.validationIndex].includes(field);
      },
    }
  };
</script>
